import { getPagePathByLocale, shoppingBagPage } from "@lib/constants/pagePaths";
import { useStore } from "@store/store";
import useIsomorphicLayoutEffect from "@ui/hooks/useIsomorphicLayoutEffect";
import { useRouter } from "next/router";
import { useEffect } from "react";

const DEFAULT_LIMIT = 10;

type Config = {
    shouldRedirect?: boolean;
};

export const useOrderItemsLimit = (country: string, config?: Config) => {
    const setItemsLimitReached = useStore((state) => state.setItemsLimitReached);
    const cart = useStore((state) => state.data.me.cartInfo?.cart);
    const itemsLimitReached = useStore((state) => state.data.me.cartInfo?.itemsLimitReached);

    const { push, locale } = useRouter();

    const countryItemsLimit = {
        US: DEFAULT_LIMIT,
        CA: DEFAULT_LIMIT,
        MY: DEFAULT_LIMIT,
        SG: DEFAULT_LIMIT,
        ES: DEFAULT_LIMIT,
        EE: DEFAULT_LIMIT,
        IN: DEFAULT_LIMIT,
        KR: DEFAULT_LIMIT,
        AU: DEFAULT_LIMIT,
    };

    const redirectBackToBag = () => {
        push(`${getPagePathByLocale(shoppingBagPage, locale)}`);
    };

    useEffect(() => {
        const itemsCount = cart?.lineItems?.reduce((total, item) => total + item.quantity, 0);

        setItemsLimitReached(itemsCount > countryItemsLimit[country]);
    }, [cart]);

    useIsomorphicLayoutEffect(() => {
        if (!config?.shouldRedirect || !itemsLimitReached) return;
        redirectBackToBag();
    }, [itemsLimitReached]);

    return {
        itemsLimit: countryItemsLimit[country],
    };
};
